import React, { useState, useEffect } from "react";
import BeatLoader from "react-spinners/BeatLoader";
import Chip from '@material-ui/core/Chip';
import swal from 'sweetalert'
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styles from "assets/jss/material-kit-react/views/learningPage.js";
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import md5 from "md5";
import Divider from '@material-ui/core/Divider';
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(styles);

export default function DocumentInquiry(props) {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(true);

  const [state, setState] = React.useState({
    code: "",
    url: "/Classes/Certificate/notfound.png"
  });
  function Inquiry() {
    setState({ ...state, ["url"]: "/Classes/Certificate/" + md5(state.code) + ".png" });
  }
  function AsDefault() {
    setState({ ...state, ["url"]: "/Classes/Certificate/notfound.png" });
    swal("گواهینامه یافت نشد.")
  }
  const handleTextBoxChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };
 

  return (
    <div className={classes.container}>
      <div className={classes.center + " " + classes.fastAccess + " " + classes.hidden}>
        <BeatLoader loading={loading} color={"gray"} size={15} />
      </div>

      <GridContainer justify="left" className={classes.box}>
        <GridItem className={classes.rightAlign} xs={12} sm={12} md={8}>
          <form className={classes.root} noValidate autoComplete="off">
            <TextField id="standard-basic" name="code" onChange={handleTextBoxChange} value={state.code} label="کد پیگیری" helperText="این کد را در پایان دوره دریافت کرده اید." />
          </form>
          <div>
          <Button variant="contained" onClick={() => { Inquiry() }} color="primary" disableElevation>
            استعلام مدرک
          </Button>
          </div>
          <div className={classes.box+" "+classes.left}>
            <a href={state.url} target="_blank"><img className={classes.img} src={state.url} onError={() => AsDefault()}></img></a>
          </div>
        </GridItem>
        <GridItem className={classes.justifyAlign} xs={12} sm={12} md={4}>
        <Typography variant="caption" display="block" gutterBottom>
        <strong>صدور گواهینامه</strong>
      </Typography>
        <Typography variant="caption" display="block" gutterBottom>
        پس از شرکت در دوره‌ها، با تایید مدرس دوره و گذراندن آزمون دوره، گواهینامه‌ای شامل نام و نام خانوادگی، نام دوره گذارنده شده همراه با تاریخ و مدت برگزاری، برای شما صادر شده و از طریق سایت قابل استعلام خواهد بود.
      </Typography>
      <Typography variant="caption" display="block" gutterBottom>
      </Typography>
      <Divider light  variant="middle" className={classes.divider}/>
      <Typography variant="caption" display="block" gutterBottom>
        <strong>اصالت گواهینامه</strong>
      </Typography>
      <Typography variant="caption" display="block" gutterBottom>
در هر گواهینامه کدی لحاظ شده است با عنوان "کد پیگیری اختصاصی شما" که با وارد کردن آن در بخش استعلام گواهینامه در سایت، میتوان اصالت گواهینامه را احراز نمود.
      </Typography>
      <Typography variant="caption" display="block" gutterBottom>
گواهینامه‌های فیزیکی دارای هولوگرام هستند که نشانه اصالت آنهاست.
<br />
<br />
<div  className={classes.center}>
{//<img src="/Classes/Certificate/hologram.jpg"/>
}
</div>
      </Typography>
      <Divider light  variant="middle" className={classes.divider}/>
      <Typography variant="caption" display="block" gutterBottom>
        <strong>گواهینامه فیزیکی</strong>
      </Typography>
      <Typography variant="caption" display="block" gutterBottom>
        در صورت درخواست شما، گواهینامه فیزیکی نیز صادر گردیده و به آدرس سازمان یا شخص شما ارسال می‌گردد. هزینه ارسال گواهینامه از طریق پست با دانشجوی گرامی خواهد بود.
      </Typography>
        </GridItem>
      </GridContainer>
      <div className={classes.description}>
        <p>
          {" "}
        </p>
      </div>
      <GridContainer justify="center">
      </GridContainer>
    </div>
  );
}





